module.exports = __webpack_public_path__ + "img/BINDI 2 LIME.5dd1bd2.svg";